export default {
  toast: {
    description: "",
    display: false,
    type: "",
    messageTitle: "",
  },
  loading: false,
  smallLoading: false,
  carousel: [],
};
